import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { ALL_REPORTS_GROUP_SORT_BYS, IReportGroupSortBy } from "reports/model"
import { setReportsParameters } from "reports/tools/common"
import { getReportForm } from "reports/tools/ui"
import { FlexBox } from "ui/components/FlexBox"

interface IReportParametersGroupByProps {
  isCreation: boolean
}

interface IReportParametersGroupByConnectProps {
  groupBys: IReportGroupSortBy[]
}

const ReportParametersGroupByFn = React.memo(
  ({ isCreation, groupBys }: IReportParametersGroupByProps & IReportParametersGroupByConnectProps) => (
    <FlexBox jc="start" fullWidth gap>
      <FormGroup
        id="reports-group-by-div-container"
        sx={{
          "flexDirection": "row",
          "& > *": {
            width: "8rem"
          },
          "& .MuiFormControlLabel-root .MuiFormControlLabel-label": {
            fontSize: ".8rem"
          }
        }}>
        <FormControlLabel
          id="reports-group-by-all"
          control={
            <Checkbox
              checked={groupBys.length === ALL_REPORTS_GROUP_SORT_BYS.length}
              indeterminate={groupBys.length > 0 && groupBys.length < ALL_REPORTS_GROUP_SORT_BYS.length}
            />
          }
          label={translate("label.select.filter.all")}
          onChange={(_event, newIsSelected) =>
            setReportsParameters(isCreation, { groupBys: newIsSelected ? ALL_REPORTS_GROUP_SORT_BYS.slice() : [] })
          }
        />
        {ALL_REPORTS_GROUP_SORT_BYS.map((groupSortBy, index) => (
          <FormControlLabel
            id={`reports-group-by-${groupSortBy}`}
            key={index}
            control={<Checkbox checked={groupBys.contains(groupSortBy)} />}
            label={translate(`report.group.sort.by.${groupSortBy}`)}
            onChange={(_event, newIsSelected) => {
              const newSelectedList = groupBys.slice()
              if (newIsSelected) {
                newSelectedList.push(groupSortBy)
              } else {
                newSelectedList.remove(groupSortBy)
              }
              setReportsParameters(isCreation, { groupBys: newSelectedList })
            }}
          />
        ))}
        {groupBys.length === 0 && (
          <Typography color="error" fontSize=".9rem" textAlign="end" sx={{ m: "1rem", mb: 0, width: "100%" }}>
            {translate("reports.groupBy.must.select")}
          </Typography>
        )}
      </FormGroup>
    </FlexBox>
  )
)

export const ReportParametersGroupBy = connect(
  (state: IRootState, ownProps: IReportParametersGroupByProps): IReportParametersGroupByConnectProps => ({
    groupBys: getReportForm(ownProps.isCreation, state.reports).parameters.groupBys
  })
)(ReportParametersGroupByFn)
